import React, { useEffect, useState } from "react";
import Payments from "./Payments";
import { useDispatch, useSelector } from "react-redux";
import {
  updateShowTakePaymentDrawer,
  updateDisplayNoShowModal,
  updateDisplayCancelBookingModal,
  updateShowApplyDiscountDrawer,
  updateShowRefundPaymentDrawer,
  updateShowSendPaymentLinkDrawer,
  updateShowAttachToPartyDrawer,
  updateDisplayDeletePartyModal,
  updateDisplayDeleteBookingModal,
  updateDisplayUndoCompletedBookingModal,
  updateDisplayUndoNoShowBookingModal,
} from "../../../reducer/bookingReducer";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";
import { CircularProgress } from "@mui/material";
import { getPartyById } from "../../../reducer/partyReducer";
import { CiDiscount1 } from "react-icons/ci";
import moment from "moment";
import { useMemo } from "react";
import RefundIcon from "../../../assets/images/svgs/Refund.svg";
import { FaUndo } from "react-icons/fa";
import { FaLink } from "react-icons/fa6";
import { BiEdit } from "react-icons/bi";
import { GoTrash } from "react-icons/go";
import { IoSend } from "react-icons/io5";
import CheckoutDrawer from "../DrawerPages/CheckoutDrawer";
import SendPaymentLinkDrawer from "../DrawerPages/SendPaymentLinkDrawer";

const Footer = ({ isBookingAlterationAllowed }) => {
  const {
    showMainBookingDetailsDrawer,
    invoiceDetails,
    paymentDetails,
    bookingHotelId,
    bookingDetails,
  } = useSelector((store) => store.booking);
  const { editBookingAllowed, deleteBookingAllowed } = useSelector(
    (store) => store.usersRestriction
  );
  const {hotelDetails} = useSelector((store) => store.login); 

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    handleCheckIn,
    handleCheckOut,
    handleUndoCheckIn,
    handleConfirmBooking,
    checkOutConditional
  } = useAllBookingFunction(setLoading);

  const [attachedPartyName, setAttachedPartyName] = useState("");

  useEffect(() => {
    let isPartyAttached = paymentDetails?.find(
      (payment) => payment?.method === "btc"
    );

    setAttachedPartyName("");

    async function performApi(isPartyAttached) {
      if (
        isPartyAttached &&
        isPartyAttached?.paymentModePartyId &&
        bookingHotelId
      ) {
        const res = await dispatch(
          getPartyById({
            hotelId: bookingHotelId,
            id: isPartyAttached?.paymentModePartyId,
          })
        );
        if (res?.payload?.status == 200) {
          setAttachedPartyName(res?.payload?.data?.displayName);
        }
      }
    }

    performApi(isPartyAttached);
  }, [paymentDetails]);

  let roomBill = Array.isArray(invoiceDetails)
    ? invoiceDetails?.find((Obj) => Obj?.invoiceType === "roomBill")
    : {};

  // --- Discount Comment Display ---
  // Find discount comment if present
  const discountComment = roomBill?.discountInfo?.comment;

  let isPosBillAttached = Array.isArray(invoiceDetails)
    ? Boolean(
        invoiceDetails?.filter((obj) => obj.invoiceType === "pos")?.length > 0
      )
    : false;

  let isPartyAttached = paymentDetails?.find(
    (payment) => payment?.method === "btc"
  );

  return (
    <footer>

      {["upcoming", "confirmed", "new"].includes(
        showMainBookingDetailsDrawer?.bookingType
      ) && (
        <UpcomingFooter
          isBookingAlterationAllowed={isBookingAlterationAllowed}
          editBookingAllowed={editBookingAllowed}
          dispatch={dispatch}
          roomBill={roomBill}
          loading={loading}
          deleteBookingAllowed={deleteBookingAllowed}
          handleCheckIn={handleCheckIn}
          bookingDetails={bookingDetails}
          hotelDetails={hotelDetails}
        />
      )}

      {["checkedIn", "ongoing"].includes(
        showMainBookingDetailsDrawer?.bookingType
      ) && (
        <OngoingFooter
          isBookingAlterationAllowed={isBookingAlterationAllowed}
          isPartyAttached={isPartyAttached}
          attachedPartyName={attachedPartyName}
          dispatch={dispatch}
          roomBill={roomBill}
          loading={loading}
          isPosBillAttached={isPosBillAttached}
          handleUndoCheckIn={handleUndoCheckIn}
          deleteBookingAllowed={deleteBookingAllowed}
          handleCheckOut={checkOutConditional}
        />
      )}

      <CheckoutDrawer/>
      <SendPaymentLinkDrawer/>
      {showMainBookingDetailsDrawer?.bookingType === "completed" && (
        <CompletedFooter
          isBookingAlterationAllowed={isBookingAlterationAllowed}
          editBookingAllowed={editBookingAllowed}
          isPartyAttached={isPartyAttached}
          attachedPartyName={attachedPartyName}
          dispatch={dispatch}
          roomBill={roomBill}
          loading={loading}
        />
      )}

      {showMainBookingDetailsDrawer?.bookingType === "enquiry" && (
        <EnquiryFooter
          isBookingAlterationAllowed={isBookingAlterationAllowed}
          deleteBookingAllowed={deleteBookingAllowed}
          dispatch={dispatch}
          roomBill={roomBill}
          loading={loading}
          handleConfirmBooking={handleConfirmBooking}
        />
      )}

      {showMainBookingDetailsDrawer?.bookingType === "noShow" && (
        <NoShowFooter
          isBookingAlterationAllowed={isBookingAlterationAllowed}
          deleteBookingAllowed={deleteBookingAllowed}
          dispatch={dispatch}
          loading={loading}
          bookingDetails={bookingDetails}
        />
      )}
    </footer>
  );
};

const UpcomingFooter = ({
  isBookingAlterationAllowed,
  dispatch,
  roomBill,
  loading,
  deleteBookingAllowed,
  handleCheckIn,
  bookingDetails,
  hotelDetails
}) => {
  const showNoShow = useMemo(() => {
    const offset = hotelDetails?.zoneOffset; // e.g. "+05:30"
    // Parse check-in in hotel's local time
    if(!bookingDetails?.checkIn || !offset) return false;
    const checkInLocal = moment(bookingDetails?.checkIn).utcOffset(offset);
    // Start of today at 00:00 in that offset
    const startOfToday = moment().utcOffset(offset).subtract(1,"day").startOf("day");
    // End of tomorrow at 23:59:59 in that offset
    const endOfTomorrow = moment().utcOffset(offset).subtract(1, "day").endOf("day");
    
    return checkInLocal.isBetween(startOfToday, endOfTomorrow, null, "[]");
  }, [bookingDetails?.checkIn, hotelDetails?.zoneOffset]);
  return (
    <div className=" absolute  right-[-1px] bottom-[-1px] flex flex-col items-center  gap-2 w-[100%]  text-[1.125rem] font-[600] bg-[#FFF] border border-t-[#00000015] rounded-t-[0.9375rem]">
      <Payments />

      <div className="w-[100%] flex justify-center gap-3  pt-2">
        {isBookingAlterationAllowed && (
          <>
            {" "}
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 items-center bg-[#ECFDF3] font-[500] text-[#039855] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowApplyDiscountDrawer())}
            >
              <CiDiscount1 />{" "}
              {roomBill?.discount
                ? ` Edit Discount${roomBill?.discountInfo?.comment ? ` (${roomBill.discountInfo.comment})` : ''}`
                : " Apply Discount"}
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowRefundPaymentDrawer())}
            >
              <img src={RefundIcon} alt="" />
              Refund
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowSendPaymentLinkDrawer())}
            >
              <IoSend />
              Send Payment Link
            </button>
            {showNoShow && <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateDisplayNoShowModal())}
            >
              No Show
            </button>}
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#F36960] font-[500] bg-[#526EFF0D] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateDisplayCancelBookingModal())}
            >
              Cancel Booking
            </button>
          </>
        )}

        {deleteBookingAllowed && (
          <button
            className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#D92D20] font-[500] bg-[#FEF3F2] px-2 py-2 rounded-md"
            onClick={() => dispatch(updateDisplayDeleteBookingModal())}
          >
            Delete Booking
          </button>
        )}
      </div>

      {Boolean(isBookingAlterationAllowed) && (
        <div className=" w-[100%] ">
          <button
            className="w-[50%] font-[500] text-[16px] bg-[#EAF2FD] py-2 text-[#007FFF] "
            onClick={() => dispatch(updateShowTakePaymentDrawer())}
          >
            TAKE PAYMENT
          </button>

          <button
            className="w-[50%] font-[500] text-[16px] text-[#FFF] py-2  bg-[#007FFF] "
            onClick={loading ? undefined : handleCheckIn}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "CHECK-IN"
            )}
          </button>
        </div>
      )}
    </div>
  );
};

const OngoingFooter = ({
  isBookingAlterationAllowed,
  isPartyAttached,
  attachedPartyName,
  dispatch,
  roomBill,
  loading,
  isPosBillAttached,
  handleUndoCheckIn,
  deleteBookingAllowed,
  handleCheckOut,
}) => {
  return (
    <div
      className=" absolute  right-[-1px] bottom-[-1px] flex flex-col gap-2 w-[100%] items-center text-[1.125rem]
   font-[600] bg-[#FFF] border border-t-[#00000015] rounded-t-[0.9375rem]"
    >
      <Payments />

      <div className="flex gap-3">
        {isBookingAlterationAllowed && (
          <>
            {isPartyAttached ? (
              <div
                className="text-xs h-[36px] whitespace-nowrap flex gap-2 justify-center items-center 
                  bg-[#E5F3F3] text-[#119199] font-outfit font-[500] p-2 rounded-[8px]"
              >
                <FaLink />

                <span className="pr-2">
                  Bill Attached to {attachedPartyName?.substring(0, 15)}{" "}
                </span>

                <BiEdit
                  className="text-[#007FFF] cursor-pointer  h-[18px] w-[18px]"
                  onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
                />

                <GoTrash
                  className="cursor-pointer text-[#FE594E] h-[18px] w-[18px]"
                  onClick={() =>
                    dispatch(
                      updateDisplayDeletePartyModal({
                        display: true,
                        partyName: attachedPartyName,
                      })
                    )
                  }
                />
              </div>
            ) : (
              <button
                className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
                onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
              >
                Attach to Party
              </button>
            )}

            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 items-center bg-[#ECFDF3] font-[500] text-[#039855] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowApplyDiscountDrawer())}
            >
              <CiDiscount1 />{" "}
              {roomBill?.discount
                ? ` Edit Discount${roomBill?.discountInfo?.comment ? ` (${roomBill.discountInfo.comment})` : ''}`
                : " Apply Discount"}
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] 
            font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowRefundPaymentDrawer())}
            >
              <img src={RefundIcon} alt="" />
              Refund
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] 
            font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowSendPaymentLinkDrawer())}
            >
              <IoSend />
              Send Payment Link
            </button>

            {!isPosBillAttached && (
              <div
                className="text-[12px] flex h-[36px] whitespace-nowrap items-center gap-2 text-[#808080] font-[400] font-[Poppins]
             bg-[#526EFF0D] px-3 py-2 rounded-md cursor-pointer leading-[20px]"
                onClick={loading ? undefined : handleUndoCheckIn}
              >
                {loading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <>
                    <FaUndo
                      color="#808080"
                      className="font-[300] text-[11px]"
                    />

                    <p> Undo Checkin</p>
                  </>
                )}
              </div>
            )}
          </>
        )}

        {Boolean(deleteBookingAllowed) && (
          <button
            className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#D92D20] font-[500] bg-[#FEF3F2] px-2 py-2 rounded-md"
            onClick={() => dispatch(updateDisplayDeleteBookingModal())}
          >
            Delete Booking
          </button>
        )}
      </div>

      {Boolean(isBookingAlterationAllowed) && (
        <div className=" w-[100%] ">
          <button
            className="w-[50%] font-[500] text-[16px] bg-[#EAF2FD] py-2 text-[#007FFF] "
            onClick={() => dispatch(updateShowTakePaymentDrawer())}
          >
            TAKE PAYMENT
          </button>

          <button
            className="w-[50%] font-[500] text-[16px] text-[#FFF] py-2  bg-[#007FFF] "
            onClick={loading ? undefined : handleCheckOut}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "CHECK-OUT"
            )}
          </button>
        </div>
      )}
    </div>
  );
};

const CompletedFooter = ({
  isBookingAlterationAllowed,
  isPartyAttached,
  attachedPartyName,
  dispatch,
  roomBill,
  loading,
}) => {
  return (
    <div
      className="absolute right-[-1px] bottom-[-8px] flex flex-col gap-2 w-full pl-[-2rem]  
        items-center text-[1.125rem] font-[600] bg-[#FFF] border border-b-0 border-l-0 border-t-[#00000015] 
        rounded-t-[0.9375rem] mb-2"
    >
      <Payments />

      {Boolean(isBookingAlterationAllowed) && (
        <>
          {" "}
          <div className="w-full flex justify-center gap-5">
            {isPartyAttached ? (
              <div
                className="text-xs h-[36px] whitespace-nowrap flex gap-2 justify-center items-center 
                bg-[#E5F3F3] text-[#119199] font-outfit font-[500] p-2 rounded-[8px]"
              >
                <FaLink />
                <span className="pr-2">
                  Bill Attached to {attachedPartyName?.substring(0, 15)}{" "}
                </span>
                <BiEdit
                  className="text-[#007FFF] cursor-pointer  h-[18px] w-[18px]"
                  onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
                />
                <GoTrash
                  className="cursor-pointer text-[#FE594E] h-[18px] w-[18px]"
                  onClick={() =>
                    dispatch(
                      updateDisplayDeletePartyModal({
                        display: true,
                        partyName: attachedPartyName,
                      })
                    )
                  }
                />
              </div>
            ) : (
              <button
                className="text-[0.875rem] h-[36px]  whitespace-nowrap bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
                onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
              >
                Attach to Party
              </button>
            )}

            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 items-center bg-[#ECFDF3] font-[500] text-[#039855] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowApplyDiscountDrawer())}
            >
              <CiDiscount1 />
              {roomBill?.discount
                ? ` Edit Discount${roomBill?.discountInfo?.comment ? ` (${roomBill.discountInfo.comment})` : ''}`
                : " Apply Discount"}
            </button>

            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex items-center gap-2 bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowRefundPaymentDrawer())}
            >
              <img src={RefundIcon} alt="Refund Icon" />
              Refund
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowSendPaymentLinkDrawer())}
            >
              <IoSend />
              Send Payment Link
            </button>

            <div
              className="text-[12px] flex  h-[36px] whitespace-nowrap items-center gap-2 text-[#808080] font-[400] font-[Poppins]
              bg-[#526EFF0D] px-3 py-2 rounded-md cursor-pointer leading-[20px]"
              onClick={
                loading
                  ? undefined
                  : () => dispatch(updateDisplayUndoCompletedBookingModal(true))
              }
            >
              <FaUndo color="#808080" className="font-[300] text-[11px]" />
              {loading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <p>Undo Check-out</p>
              )}
            </div>

            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#D92D20] font-[500] bg-[#FEF3F2] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateDisplayDeleteBookingModal())}
            >
              Delete Booking
            </button>
          </div>
          <button
            className="w-full py-3 font-[500] text-[16px] text-[#FFF] bg-[#007FFF]"
            onClick={() => dispatch(updateShowTakePaymentDrawer())}
          >
            TAKE PAYMENT
          </button>
        </>
      )}
    </div>
  );
};

const NoShowFooter = ({
  isBookingAlterationAllowed,
  deleteBookingAllowed,
  loading,
  dispatch,
  bookingDetails,
}) => {
  return (
    <div
      className=" absolute  right-[-1px] bottom-[0] flex flex-col justify-center items-center  gap-0
     w-[100%]  text-[1.125rem]  pb-4 border-b-0 font-[600]
      bg-[#FFF] border border-t-[#00000015] rounded-t-[0.9375rem]"
    >
      <div className="flex gap-2 pt-[10px] items-center">
        {Boolean(isBookingAlterationAllowed) && (
          <div
            className="text-[12px] flex items-center gap-2 text-[#808080] font-[400] font-[Poppins]
           bg-[#526EFF0D] px-3 py-2 rounded-md cursor-pointer leading-[20px]"
            onClick={
              loading
                ? undefined
                : () => dispatch(updateDisplayUndoNoShowBookingModal(true))
            }
          >
            <FaUndo color="#808080" className="font-[300] text-[11px]" />

            <p className="capitalize">
              {loading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <span className="capitalize">
                  Undo {bookingDetails?.status}{" "}
                </span>
              )}{" "}
            </p>
          </div>
        )}

        {Boolean(deleteBookingAllowed) && (
          <button
            className="text-[0.875rem] text-[#D92D20] font-[500] bg-[#FEF3F2] px-2 py-2 rounded-md"
            onClick={() => dispatch(updateDisplayDeleteBookingModal())}
          >
            Delete Booking
          </button>
        )}
      </div>
      <Payments />{" "}
    </div>
  );
};

const EnquiryFooter = ({
  isBookingAlterationAllowed,
  deleteBookingAllowed,
  dispatch,
  roomBill,
  loading,
  handleConfirmBooking,
}) => {
  return (
    <div
      className=" absolute  right-[-1px] bottom-[-1px] flex flex-col gap-[12px] w-[100%] items-center text-[1.125rem] font-outfit
   font-[600] bg-[#FFF] border border-t-[#00000015] rounded-t-[0.9375rem]"
    >
      <Payments />

      <div className="flex items-center  justify-center gap-2">
        {isBookingAlterationAllowed && (
          <>
            {" "}
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 items-center bg-[#ECFDF3] font-[500] text-[#039855] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowApplyDiscountDrawer())}
            >
              <CiDiscount1 />{" "}
              {roomBill?.discount
                ? ` Edit Discount${roomBill?.discountInfo?.comment ? ` (${roomBill.discountInfo.comment})` : ''}`
                : " Apply Discount"}
            </button>
            <button
              className="text-[0.875rem] h-[36px] flex gap-2 justify-center items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowRefundPaymentDrawer())}
            >
              <img src={RefundIcon} alt="" />
              Refund
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateShowSendPaymentLinkDrawer())}
            >
              <IoSend />
              Send Payment Link
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap bg-[#526EFF0D] font-[500] text-[#007FFF] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateDisplayNoShowModal())}
            >
              No Show
            </button>
            <button
              className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#F36960] font-[500] bg-[#526EFF0D] px-2 py-2 rounded-md"
              onClick={() => dispatch(updateDisplayCancelBookingModal())}
            >
              Cancel Booking
            </button>
          </>
        )}

        {Boolean(deleteBookingAllowed) && (
          <button
            className="text-[0.875rem] h-[36px] whitespace-nowrap text-[#D92D20] font-[500] bg-[#FEF3F2] px-2 py-2 rounded-md"
            onClick={() => dispatch(updateDisplayDeleteBookingModal())}
          >
            Delete Booking
          </button>
        )}
      </div>

      <div className=" w-[100%] flex items-center ">
        {Boolean(isBookingAlterationAllowed) && (
          <>
            <button
              type="primary"
              className="flex-1  py-2 font-[500] text-[16px] leading-[24px] h-[50px] bg-[#526EFF0D]  text-[#007FFF] "
              onClick={() => dispatch(updateShowTakePaymentDrawer())}
            >
              TAKE PAYMENT
            </button>

            <button
              className="flex-1 text-[#FFF] font-[500] text-[16px] leading-[24px] h-[50px] py-2  bg-[#007FFF] "
              onClick={loading ? undefined : handleConfirmBooking}
            >
              {loading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                "Confirm Booking"
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
